import { useAtom } from "jotai";
import React, { useRef } from "react";

import { GradientButton } from "../../../shared/components/fkl-gradient-button/fkl-gradient-button.component";
import { handleAssetUrl } from "../../../shared/utils";
import { socialReferralPageAtom } from "../../social-referral.state";

interface SocialIconsItem {
  url: string;
  alt: string;
  shareableLink: string;
}

export const SOCIAL_SHARE: SocialIconsItem[] = [
  {
    url: "fkl-facebook-icon.png",
    alt: "Facebook share",
    shareableLink: "//www.facebook.com/sharer.php?u=",
  },
  {
    url: "twitter-fkl.png",
    alt: "Twitter share",
    shareableLink: "//twitter.com/share?text=",
  },
  {
    url: "fkl-mail-icon.png",
    alt: "Mail share",
    shareableLink: "mailto:?body=",
  },
  {
    url: "fkl-snapchat-icon.png",
    alt: "Snapchat share",
    shareableLink: "https://snapchat.com/scan?attachmentUrl=",
  },
  {
    url: "fkl-whatsapp-icon.png",
    alt: "Whatsapp share",
    shareableLink: "whatsapp://send?text=",
  },
];

export const SocialReferralFooter: React.FC = () => {
  const [socialReferralPage] = useAtom(socialReferralPageAtom);
  const { pageMetafields, pageHandle } = window.FKL;
  const copiedMessageRef = useRef<HTMLDivElement>(null);

  const proceedToNextPage = () => {
    window.location.href = window.theme.Routing.redirectToNextPage(
      pageMetafields,
      pageHandle.replace("-social-referral", "")
    );
  };

  const copyToClipboard = (socialReferralLink: string) => {
    navigator.clipboard.writeText(socialReferralLink);
    copiedMessageRef.current?.classList.add("show--message");
  };

  return (
    <div className="social-referral__footer">
      <div className="social-referral__footer--title">
        Copy and Share your FindKeepLove referral link to earn more entries!
      </div>
      <div className="social-referral__footer--referral-link">
        <div className="social-referral__footer--output-link-container">
          <input
            className="social-referral__footer--output-link"
            id="social-referral-link"
            type="text"
            readOnly
            value={socialReferralPage.social_referral_link}
          />
        </div>
        <div className="social-referral__footer--output-action">
          <GradientButton
            variant="large-button"
            onClick={() =>
              copyToClipboard(socialReferralPage.social_referral_link)
            }
          >
            Copy Link
          </GradientButton>
          <div className="social-referral__footer--copied-message-container">
            <span
              ref={copiedMessageRef}
              className="social-referral__footer--copied-message"
            >
              Link copied to clipboard!
            </span>
          </div>
        </div>
      </div>
      <div className="social-referral__footer--social-share">
        <div className="social-referral__footer--social-share-container">
          <div className="social-referral__footer--social-share-description">
            Or share via...
          </div>
          {SOCIAL_SHARE.map((icon: SocialIconsItem, index) => {
            return (
              <a
                className="social-referral__footer--social-share-link"
                key={index}
                href={
                  icon.shareableLink +
                  encodeURIComponent(socialReferralPage.social_referral_link)
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="social-referral__footer--social-share-icons"
                  src={handleAssetUrl(icon.url)}
                  alt={icon.alt}
                />
              </a>
            );
          })}
        </div>
        <button
          className="social-referral__footer--skip"
          onClick={() => proceedToNextPage()}
        >
          {"Don't want to share? Proceed."}
        </button>
      </div>
    </div>
  );
};
